// Exports
export default {
	"startScreenPopup": "startScreenPopup_26Qpj",
	"container": "container_wWeOD",
	"loader": "loader_RFwj6",
	"iframe": "iframe_9p-1m",
	"iframeWrapper": "iframeWrapper_-XcBL",
	"hidden": "hidden_JOqrf"
};
